<template>
  <div class="view-max-shell">
    <div class="w-view-shell">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"
        >当前位置：首页</el-breadcrumb-item
        >
        <el-breadcrumb-item >帮助中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{issueName}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="issue-content" v-html="protocol_info">

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "issue",
  data(){
    return{
      protocol_info: '',
      issueName: '',
      protocol_type: 1 // 1.操作手册；2.修改信息；3.开具发票，4，上传头像；5.考核相关 6 .联系我们
    }
  },
  mounted () {
    this.issueName = this.$route.query.name
    this.protocol_type = this.$route.query.protocol_type
    this.get_issue()
  },
  methods:{
    get_issue(){
      this.API.post( 'Home/article_out-get_protocol',{
        protocol_type: this.protocol_type
      }).then((res)=>{
        this.protocol_info = res.data.protocol_info
      })
    }
  }
};
</script>
<style lang="less" scoped>
.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 400;
  color: #000;
  cursor: text;
}
.view-max-shell{
  background-color: #fff;
  min-height: 100vh;
}
.el-breadcrumb {
  margin-top: 30px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
  .w-view-shell{
    padding: 10px;
    .issue-content{
      border-top: 1px solid #eee;
      margin-top: 20px;
      min-height: 30vh;
      padding: 20px;
    }
  }
</style>
